import SEO from "@/components/SEO";
import { Container, PrimaryButton } from "@/components/primitives";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <section className="flex min-h-screen items-center">
        <Container className="text-center">
          <p className="font-mono text-sm uppercase tracking-[0.2em] text-accent">
            404
          </p>
          <h1 className="mt-6 font-cabinet text-5xl font-medium tracking-tight text-primary-ink md:text-7xl">
            Page not found.
          </h1>
          <p className="mx-auto mt-6 max-w-md text-lg leading-relaxed text-secondary-ink">
            The page you're looking for has moved or never existed. Let's get you
            back on track.
          </p>
          <div className="mt-10 flex justify-center">
            <PrimaryButton to="/" testId="notfound-home">
              Back to Home
            </PrimaryButton>
          </div>
        </Container>
      </section>
    </>
  );
}
